module.exports = __webpack_public_path__ + "img/16.c36f5d96.jpg";